import {useEffect} from 'react'

const SCROLLED_ATTRIBUTE = 'data-asa-scrolled'
const PROGRESS_PROPERTY = '--asa-page-p'

// The site's scroll cues for the panel: html[data-asa-scrolled] once the page has moved (the header
// gains its border) and --asa-page-p from 0 to 1 for the reading-progress line under the header.
// Updates are batched to one per animation frame.
export const useScrollState = () => {
  useEffect(() => {
    const root = document.documentElement
    let frame = 0

    const update = () => {
      frame = 0
      const scrollTop = window.scrollY || root.scrollTop
      const scrollable = root.scrollHeight - window.innerHeight
      if (scrollTop > 8) root.setAttribute(SCROLLED_ATTRIBUTE, '')
      else root.removeAttribute(SCROLLED_ATTRIBUTE)
      root.style.setProperty(
        PROGRESS_PROPERTY,
        scrollable > 0 ? Math.min(1, scrollTop / scrollable).toFixed(4) : '0'
      )
    }

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', schedule, {passive: true})
    window.addEventListener('resize', schedule)
    return () => {
      window.removeEventListener('scroll', schedule)
      window.removeEventListener('resize', schedule)
      if (frame) window.cancelAnimationFrame(frame)
      root.removeAttribute(SCROLLED_ATTRIBUTE)
      root.style.removeProperty(PROGRESS_PROPERTY)
    }
  }, [])
}
